import React from 'react';
import { useState } from 'react';
import brokerService from '../../services/broker.service';
import { useNavigate } from 'react-router-dom';

interface BrokerModel {
    name: string;
}

function AddBrokerForm() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState<BrokerModel>({} as BrokerModel);
    const [errors, setErrors] = useState({ name: '' });

    const inputHandleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'name' && value?.trim() === '') {
            setErrors(prevState => ({
                ...prevState,
                name: 'Name is required'
            }));
        } else {
            setErrors(prevState => ({
                ...prevState,
                name: ''
            }));
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (formData.name.trim() === '') {
            setErrors(prevState => ({
                ...prevState,
                name: 'Name is required'
            }));
            return;
        }
        saveBroker(formData);
        console.log(formData);
    };

    const saveBroker = (formData: BrokerModel) => {
        brokerService.createBroker(formData).then((response) => {
            console.log('Brokers:', response.data.data);
            navigate('/broker');
        }).catch((error) => {
            console.log('Error create broker:', error);
        });
    };

    const handleReset = () => {
        setFormData({
            name: ''
        });
        setErrors({
            name: ''
        });
    };

    return (<>
        <div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '100px' }}>
                <div style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', width: '300px' }}>
                    <h3 className='titleColor' style={{ textAlign: 'center', marginBottom: '20px' }}>Add Broker</h3>
                    <form>
                        <div className=''>
                            <label htmlFor="name" style={{ display: 'block', marginBottom: '5px' }}>Name:</label>
                            <select className='form-control form-control-sm' id="name" name="name" onChange={(e) => inputHandleChange(e)}>
                                <option value="">Select Broker</option>
                                <option value="Zerodha">Zerodha</option>
                                <option value="Kite Connect">Kite Connect</option>
                                <option value="Angel One">Angel One</option>
                                <option value="Upstox">Upstox</option>
                                <option value="Fyers">Fyers</option>
                                <option value="5Paisa">5Paisa</option>
                            </select>
                            {errors.name && <span style={{ color: 'red', fontSize: '12px' }}>{errors.name}</span>}
                        </div>
                        <div className='d-flex justify-content-between mt-4'>
                            <button type="reset" className='btn btn-sm btn-outline-danger' onClick={handleReset}>Reset</button>
                            <button type="submit" className='btn btn-sm btn-outline-primary' onClick={(e) => handleSubmit(e)}>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </>);
}

export default AddBrokerForm;